import React from 'react';
import { NavigationCardList } from './navigation-card-list/index';
import { NavigationCardProps } from './navigation-card-list/card/index';
import { RiTeamLine, RiLayoutMasonryLine, RiBankCard2Fill, RiSettings3Line } from 'react-icons/ri';
import { Box } from '@material-ui/core';

const cards: NavigationCardProps[] = [
 { color: '#F79300', label: 'Members', icon: <RiTeamLine /> },
 { color: '#169DB2', label: 'Templates', icon: <RiLayoutMasonryLine /> },
 { color: '#FFC107', label: 'Member Cards', icon: <RiBankCard2Fill /> },
 { color: '#D53343', label: 'Settings', icon: <RiSettings3Line /> },
];

export default function Dashboard() {
 return (
  <Box>
   <NavigationCardList cards={cards} />
  </Box>
 );
}
